import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './PublicMainNonExistentQrModal.module.scss';
import { Modal } from '../../../CorePackage/MainModule/components/Modal';

interface IPublicMainNonExistentQrModalProps {
  onClose: () => void;
  qrModalText: string;
  visible: boolean;
}

export const PublicMainNonExistentQrModal = ({ onClose, qrModalText, visible }: IPublicMainNonExistentQrModalProps) => {
  return (
    <Modal modalBodyClassName={styles.ModalBody} visible={visible} onClose={onClose}>
      <div className={styles.Header}>
        <h4 className={styles.Title}>Уведомление</h4>
      </div>
      <div className={styles.Body}>
        <div className={styles.Content}>
          <p>{qrModalText}</p>
        </div>
      </div>
      <div className={styles.Footer}>
        <Button className={styles.SubmitButton} color="primary" type="button" onClick={onClose} text="ОК" />
      </div>
    </Modal>
  );
};
